import useAuthStore from '../stores/auth.js'

export const useAuth = () => {
	return {
		// State (use selectors for reactive state)
		isAuthenticated: useAuthStore(state => state.isAuthenticated),
		user: useAuthStore(state => state.user),
		priceFundAmount: useAuthStore(state => state.priceFundAmount),
		priceFundLabel: useAuthStore(state => state.priceFundLabel),
		loading: useAuthStore(state => state.loading),
		startYear: useAuthStore(state => state.startYear),
		endYear: useAuthStore(state => state.endYear),
		error: useAuthStore(state => state.error),

		// Actions (direct access to actions)
		login: useAuthStore(state => state.login),
		logout: useAuthStore(state => state.logout),
		checkAuth: useAuthStore(state => state.checkAuth),
		clearAuth: useAuthStore(state => state.clearAuth),
		setLoading: useAuthStore(state => state.setLoading),
		setError: useAuthStore(state => state.setError),
		setUser: useAuthStore(state => state.setUser),
		setPriceFundAmount: useAuthStore(state => state.setPriceFundAmount),
		setPriceFundLabel: useAuthStore(state => state.setPriceFundLabel),
		countDownStatus: useAuthStore(state => state.countDownStatus),
		currentWeek: useAuthStore(state => state.currentWeek),
		checkCountDown: useAuthStore(state => state.checkCountDown),
		nextWeekDetails: useAuthStore(state => state.nextWeekDetails),
		checkNextWeekDetails: useAuthStore(state => state.checkNextWeekDetails),
		getWeekly_prize_info: useAuthStore(state => state.getWeekly_prize_info),
		setStartYear: useAuthStore(state => state.setStartYear),
		setEndYear: useAuthStore(state => state.setEndYear),
		getYear: useAuthStore(state => state.getYear),
	}
}